<template>
    <div class="pt-15 animated fadeIn staticPageInner equipmentList bgV2">
        <div class="boxShadow setBorderRadius heig-frame-equipment-group">
            <b-row no-gutters>
                <b-col md="12" class="heig-frame-child">
                    <gofix-card class="mb-0 heig-frame-child" fullContent>
                        <gofix-table :settings="tableConfig"
                            :table-items="tableItems"
                            @new-item="goToDetai"
                            @load-items="getTableData"
                            @row-click="clickToRowItem"
                            @import-items="importItems"
                            @delete-items="deleteItems"
                            ref="gofixTable">
                        </gofix-table>
                    </gofix-card>
                </b-col>
            </b-row>

            <b-modal :no-close-on-backdrop="true"
                id="modal-create-item"
                modal-class="modal-create"
                title="Create new maintenance standard"
                hide-footer :centered="true"
                ref="modal-create-item"
                @hidden="resetCreateItem"
                v-model="modals.create.open">
                <div v-bind:class="{'run-loading':modals.create.loading}">
                    <b-form class="pb-20">
                        <b-row>
                            <b-col md="6">
                                <gofix-form-input label="PM code" v-model="modals.create.data.sor_code" required></gofix-form-input>
                            </b-col>
                            <b-col md="12">
                                <gofix-form-tree
                                    label="Service Category"
                                    :default-expand-level="1"
                                    :multiple="false"
                                    :options="modals.create.dataService"
                                    :load-options="loadOptionsService"
                                    :normalizer="normalizerService"
                                    search-nested
                                    required
                                    valueFormat="object"
                                    v-model="modals.create.data.service_category"
                                    ref="input">
                                </gofix-form-tree>
                            </b-col>
                            <b-col md="12">
                                <gofix-form-input label="PM Name" v-model="modals.create.data.name" required></gofix-form-input>
                            </b-col>
                            <b-col md="12">
                                <gofix-form-tree
                                    label="Equipment Group"
                                    :multiple="false"
                                    :options="modals.create.dataEquipment"
                                    :load-options="loadOptionsEquiment"
                                    :normalizer="normalizerEquipment"
                                    search-nested
                                    valueFormat="object"
                                    v-model="modals.create.data.equipment_type"
                                    placeholder="Select"
                                    ref="equipmentTree">
                                </gofix-form-tree>
                            </b-col>
                            <b-col md="6">
                                <gofix-form-dropdown
                                    label="Frequency"
                                    desc="To create “Frequency” click MORE"
                                    vLabel="recurring_mode"
                                    :clearable="false"
                                    :filterable="false"
                                    :required="true"
                                    :reduce="option => option.id"
                                    v-model="modals.create.data.sor_recurring_mode_id"
                                    :options="modals.create.dataRecurring">
                                </gofix-form-dropdown>
                            </b-col>
                            <b-col md="6">
                                <gofix-form-input label="Tolerance Period" desc="Days" v-model="modals.create.data.tolerance_period"></gofix-form-input>
                            </b-col>
                            <b-col md="12" class="mt-3">
                                <gofix-form-dropdown
                                    label="Checklist template"
                                    vLabel="name_checklist_templates"
                                    :clearable="false"
                                    :filterable="false"
                                    :required="true"
                                    :reduce="option => option.id"
                                    v-model="modals.create.data.checklist_template_id"
                                    :options="modals.create.dataChecklist">
                                </gofix-form-dropdown>
                            </b-col>
                        </b-row>
                    </b-form>
                    <b-button-group class="d-block text-right">
                        <gofix-button label="MORE" @click="goToDetai" noBorder dark></gofix-button>
                        <gofix-button label="APPLY" @click="saveData" noBorder></gofix-button>
                    </b-button-group>
                </div>
            </b-modal>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    import {LOAD_CHILDREN_OPTIONS} from '@riophae/vue-treeselect'
    import { filters } from '@/_filterVar.js'
    const simulateAsyncOperation = fn => {
        setTimeout(fn, 500)
    }
    export default {
        name: 'maintenance-master',
        components: {},
        data () {
            let filter = JSON.parse(JSON.stringify(filters['sor_master']));
            filter.is_maintenance.value = true;
            filter.is_master.value = true;
            delete filter.contract_id;
            delete filter.contract_term_id;
            return {
                tableConfig:{
                    name: 'maintenance-standard',
                    controls:{
                        create: this.$checkRole(this.$accessModule.maintenance_standard, 'create'),
                        delete: this.$checkRole(this.$accessModule.maintenance_standard, 'delete')
                    },
                    filter: filter,
                    page: 1,
                    limit: 100,
                    total: 0,
                    useDatabaseView: true,
                    sortColumn: "sor_code",
                    sortDirection: "asc",
                    fields: [
                        {
                            key: 'actions',
                            label: '',
                            thClass: 'checkbox-column text-center',
                            tdClass: 'checkbox-column text-center',
                            width: 50,
                            thStyle: "width:50px",
                        },
                        {
                            key: 'sor_code',
                            label: 'PM Code',
                            placeholder: 'search',
                            isActive: 1,
                            isFilter: true,
                            with:null,
                            thStyle: "width:auto",
                            sorting: true,
                        },
                        {
                            key: 'abbreviation',
                            label: 'Abbreviation',
                            placeholder: 'search',
                            isActive: 1,
                            isFilter: true,
                            with:150,
                            thStyle: "width:150px",
                            sorting: true,
                        },
                        {
                            key: 'name_service',
                            label: 'Service Category',
                            placeholder: 'search',
                            isActive: 1,
                            isFilter: true,
                            with:250,
                            thStyle: "width:250px",
                            sorting: true,
                        },
                        {
                            key: 'equipment_type_name',
                            label: 'Equipment Group',
                            placeholder: 'search',
                            isActive: 1,
                            isFilter: true,
                            with:220,
                            thStyle: "width:220px",
                            sorting: true,
                        },
                        {
                            key: 'recurring_mode',
                            label: 'Frequency',
                            placeholder: 'Select',
                            isActive: 1,
                            isFilter: true,
                            with:150,
                            thStyle: "width:150px",
                            sorting: true,
                        },
                        {
                            key: 'name_checklist_templates',
                            label: 'Checklist temp',
                            placeholder: 'Select',
                            isActive: 1,
                            isFilter: true,
                            with:220,
                            thStyle: "width:220px",
                            sorting: true,
                        },
                        {
                            key: 'standard_reference',
                            label: 'Standard Reference',
                            placeholder: 'Search',
                            isActive: 1,
                            isFilter: true,
                            with:200,
                            thStyle: "width:200px",
                            sorting: true,
                        },
                    ]
                },
                tableItems: [],
                modals:{
                    create:{
                        open:false,
                        loading:false,
                        validate: false,
                        data: {
                            name:null,
                            description: null,
                            sor_code:null,
                            sor_group_id:null,
                            unit_price:0,
                            unit_price_tmp:0,
                            unit_of_measurement:null,
                            max_qty:null,
                            min_qty:null,
                            contract_term_id:null,
                            service_category_id:null,
                            service_category:null,
                            equipment_type:null,
                            equipment_group_id:null,
                            is_maintenance:true,
                            tolerance_period:null,
                            sor_recurring_mode_id:null,
                            checklist_template_id:null,
                            is_master: true
                        },
                        dataService : [],
                        dataEquipment : [],
                        dataChecklist : [],
                        dataRecurring : [],
                    }
                }
            }
        },
        created () {
            // this.getDataEquipment(0,'all',true);
            // this.getDataService(0,'all',true);
            // this.getDataRecurring();
            // this.getDataChecklist();
        },
        computed: {
            ...mapGetters({
                currentRoles: 'AuthController/roles',
            })
        },
        watch: {
            "currentRoles": function(val,old){
                this.tableConfig.controls = {
                    create: this.$checkRole(this.$accessModule.maintenance_standard, 'create'),
                    delete: this.$checkRole(this.$accessModule.maintenance_standard, 'delete')
                }
            }
        },
        methods:{
            /*-- Table callback --------*/
            async getTableData(callback) {
                const { tableRequest , resolve,reject } = await callback();
                await this.$store.dispatch("v2SorController/getItems", tableRequest)
                .then(response => {
                    this.tableItems = response.items;
                    this.tableConfig.total = response.total;
                    resolve(response);
                })
                .catch(err => {
                    console.log(err);
                    this.$alertNotification("Can not load the maintenance standard", "danger");
                    reject();
                })
            },
            async clickToRowItem(item){
                this.modals.create.data = Object.assign({}, item);
                if(item.service_category_id) {
                    this.modals.create.data.service_category = {
                        id: item.service_category_id,
                        name: item.name_service || "--"
                    };
                }
                if(item.equipment_group_id) {
                    this.modals.create.data.equipment_type = {
                        id: item.equipment_group_id,
                        name: item.equipment_group_name || "--"
                    };
                }
                this.modals.create.data.unit_price_tmp = this.$accounting.formatMoney(this.modals.create.data.unit_price);
                //this.modals.create.open = true;
                this.goToDetai();
            },
            async importItems(callback){
                const { file, resolve, reject } = await callback();
                await this.$store.dispatch(`v2SorController/importMaintenanceStandard`, {
                    fileImport: file,
                })
                .then(response => {
                    let variant = 'success';
                    let msg = this.$notificationV2('importing', 'maintenance_standard');
                    let result = response.data.data;
                    if(result.data && result.data.count && result.data.count.failed ) {
                        variant = 'danger';
                        msg = "Some rows cannot be imported. Please go to Import Logs for more details.";
                    }

                    this.$alertNotification(msg, variant);
                    resolve();
                })
                .catch(error => {
                    reject(error);
                });
            },
            async deleteItems(callback){
                const { ids,filter, resolve,reject } = await callback();
                await this.$store.dispatch('v2SorController/deleteItem', ids)
                    .then(response => {
                        resolve(this.$notificationV2('deleting', 'maintenance_standard'));
                    })
                    .catch(err => {
                        reject();
                    })
            },
            /*---------------*/

            /*---- Get Data -------*/
            async getDataEquipment(parent_id,node_type,set = false){
                let dataE = [];
                await global.axios(`api/master/tree-equiqment-structures/${parent_id}`, {
                    method: "GET",
                    headers: { Accept: "application/json", },
                    params: {
                        node_type: node_type
                    },
                })
                    .then(response => {
                        dataE = response.data.data;
                    }).catch(error => {
                        console.log(error);
                    });
                if(set){
                    this.modals.create.dataEquipment = dataE;
                }else{
                    return dataE
                }
            },
            async getDataService(parent_id,node_type,set = false){
                let data = [];
                await global.axios(`api/master/tree-service-categories/${parent_id}`, {
                    method: "GET",
                    headers: { Accept: "application/json", },
                    params: {
                        node_type: node_type
                    },
                })
                    .then(response => {
                        data = response.data.data;
                    }).catch(error => {
                        console.log(error);
                    });
                if(set){
                    this.modals.create.dataService = data;
                }else{
                    return data
                }
            },
            async getDataRecurring(){
                this.$store.dispatch('SorRecurringModesController/getListSorRecurringModes')
                .then(response => {
                    this.modals.create.dataRecurring =  response.data.data
                })
                .catch(err => {
                    console.log(err);
                })
            },
            async getDataChecklist(){
                this.$store.dispatch( 'v2CheckListTemplateController/searchTemplate', [
                    1000, 1, {is_master: true}
                ])
                .then(response => {
                    this.modals.create.dataChecklist = response.data.data.items
                })
                .catch(err => {
                    console.log(err);
                });
            },
            /*---------------------------*/

            /*---- Save data ----------------------*/
            saveData(){
                //Check required data
                this.modals.create.validate = true;
                if(!this.modals.create.data.sor_code
                    || !this.modals.create.data.service_category
                    || !this.modals.create.data.name
                    || !this.modals.create.data.sor_recurring_mode_id
                    || !this.modals.create.data.checklist_template_id
                ) {
                    this.$alertNotification("Please enter in the required fields", "danger");
                    return false;
                }

                this.modals.create.data.unit_price = this.$accounting.unformat(this.modals.create.data.unit_price_tmp);
                this.modals.create.data.service_category_id = this.modals.create.data.service_category ? this.modals.create.data.service_category.id : null;
                this.modals.create.data.equipment_group_id = this.modals.create.data.equipment_type ? this.modals.create.data.equipment_type.id : null;
                this.modals.create.data.is_master = true;
                this.modals.create.data.is_maintenance = true;
                this.modals.create.loading = true;
                this.$store.dispatch("v2SorController/createItem",this.modals.create.data).then( response => {
                    this.$refs.gofixTable.reloadTableKeepFilter();
                    this.modals.create.open = false;
                    this.modals.create.loading = false;
                }).catch(err => {
                    this.modals.create.loading = false;
                    this.$alertNotification(err.response.data.error.message.error, "danger");
                });
            },
            /*---------------------------*/

            /*--------------*/
            goToDetai(){
                let item = Object.assign({}, this.modals.create.data);
                let id = item.id || 0;
                return this.$router.push(`${this.$route.path}/${id}`);
            },
            resetCreateItem(){
                this.modals.create.data = {
                    name:null,
                    description: null,
                    sor_code:null,
                    sor_group_id:null,
                    unit_price:0,
                    unit_price_tmp:0,
                    unit_of_measurement:null,
                    max_qty:null,
                    min_qty:null,
                    contract_term_id:null,
                    service_category_id:null,
                    service_category:null,
                    equipment_type:null,
                    equipment_group_id:null,
                    is_maintenance:true,
                    tolerance_period:null,
                    sor_recurring_mode_id:null,
                    checklist_template_id:null,
                    is_master: true
                }
                this.modals.create.validate = false;
            },
            loadOptionsService({ action, parentNode, callback,instanceId  }){
                if (action === LOAD_CHILDREN_OPTIONS ) {
                    simulateAsyncOperation(async () => {
                        parentNode.children = await this.getDataService(parentNode.data.id,'all');
                        callback()
                    })
                }
            },
            normalizerService(node) {
                if(node.data && !node.data.isBatch){
                    return {
                        children : undefined,
                        label: node.name
                    }
                }
                return {
                    label: node.name
                }
            },
            loadOptionsEquiment({ action, parentNode, callback }) {
                if (action === LOAD_CHILDREN_OPTIONS ) {
                    simulateAsyncOperation(async () => {
                        parentNode.children = await this.getDataEquipment(parentNode.data.id,'all');
                        callback()
                    })
                }
            },
            normalizerEquipment(node) {
                if(node.data && node.data.isBatch) {
                    return {
                        id: node.data.id,
                        label: node.data.name,
                        children: node.children
                    }
                }
                return {
                    id: node.id,
                    label: node.name,
                    children: undefined
                }
            },
            /*---------------------------*/
        }
    }
</script>
